import React, { FC } from 'react'
import { Menu, MenuProps } from '@mui/material'

const EvtToolbar: FC<MenuProps> = ({ children, ...props }) => {
    return <Menu {...props}>{children}</Menu>
}

export default EvtToolbar
